module.exports = "/_next/static/images/coin-7ab6336a11dfdf6ac23c9f00ecc5b204.svg";